/**
 * Finds the label for a field depending on event management or
 * Formsframework forms 
 * @param {NodeElement} element 
 * @returns NodeElement
 */
 function findLabel(element) {

    if (element.parentNode.querySelector('label')) {
        return element.parentNode.querySelector('label');
    } else {
        return element.parentNode.parentNode.querySelector('label');
    }
}

function validateRequiredField(event) {
    if (event.target instanceof HTMLDocument) {
        return;
    }
    if (event.target.getAttribute('required') && event.target.value === '') {
        if (findLabel(event.target)) {
            findLabel(event.target).classList.add('required-error');
        }
    } else {
        if (findLabel(event.target)) {
            findLabel(event.target).classList.remove('required-error');
        }
    }
}

document.addEventListener('blur', validateRequiredField, true);


defaultPrevented = true;
registrationForm = document.querySelector('.registration');
if (registrationForm) {
    registrationForm.addEventListener('submit', function(event) {
        if (defaultPrevented) {
            event.preventDefault();
        }
    
        var requiredElements = document.querySelectorAll('.registration [required]');
        requiredElements.forEach(function(element) {
            if (element.getAttribute('type') === 'checkbox' && !element.checked && findLabel(element)) {
                findLabel(element).classList.add('required-error');
            } else if (element.value === '' && findLabel(element)) {
                findLabel(element).classList.add('required-error');
            }
        });
        if (this.querySelectorAll('.required-error').length > 0) {
            this.querySelectorAll('.required-error')[0].scrollIntoView(false);
        } else {
            defaultPrevented = false;
            event.target.submit();
        }
    });
}
